




































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
// import SelectUrl from '@/components/selectUrl/index.vue'
import SelectUrl from '../../floorSet/components/selectUrl.vue'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class Swiper extends Vue {
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        // interval: 3000,
        name: '轮播组件',
        displayOrder: '',
        isActive: true,
        backgroundType: 0,
        backgroundUrl: null,
        isDisplayName: false,
        // 0多图组件/1商品列表/2营销活动
        componentType: 0,
        // 图片组件数据
        photosComponent: {
          displayType: 1,
          displayMode: 0,
          photoItems: [
            {
              displayOrder: 0,
              linkUrl: null,
              photoUrl: null,
            },
          ],
        },
        // 商品组件数据
        productsComponent: {
          productItems: [],
        },
        // 活动组件
        activitiesComponent: {
          activityItems: [],
        },
      }
    },
  })
  SwiperConfig!: any

  mounted() {}

  /**
   * 选择图片
   */
  picChange(e, index) {
    console.log(e)
    this.SwiperConfig.photosComponent.photoItems[index]['photoUrl'] = e[0].url
  }

  urlChange(e, index) {
    this.SwiperConfig.photosComponent.photoItems[index]['linkUrl'] = e
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.SwiperConfig.photosComponent.photoItems.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      displayOrder: 0,
      photoUrl: null,
      linkUrl: null,
    }
    // this.SwiperConfig.photoItems.unshift(obj)
    this.SwiperConfig.photosComponent.photoItems.push(obj)
  }
  // 下移item
  downItem(index) {
    this.swapArray(this.SwiperConfig.photosComponent.photoItems, index, index + 1)
  }
  // 上移item
  upItem(index) {
    this.swapArray(this.SwiperConfig.photosComponent.photoItems, index, index - 1)
  }
  // 位移公共方法
  swapArray(arr: any, index1: number, index2: number) {
    arr[index1] = arr.splice(index2, 1, arr[index1])[0]
    return arr
  }
}
